import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/index/doctor-avatar.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-01b601ba"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "expert-answer"
};
var _hoisted_2 = {
  "class": "question"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "icon-question-circle"
  }, null, -1);
});
var _hoisted_4 = {
  "class": "answer"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "avatar"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })], -1);
});
var _hoisted_6 = {
  "class": "context"
};
var _hoisted_7 = {
  key: 0,
  "class": "doctor-name"
};
var _hoisted_8 = {
  "class": "dialog"
};
var _hoisted_9 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loaded ? (_openBlock(), _createBlock(_component_el_skeleton, {
    key: 0,
    rows: 3,
    animated: ""
  })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, function (item, index) {
    return _openBlock(), _createElementBlock("div", {
      "class": "item",
      key: index
    }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("h3", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [item.otherParameter ? (_openBlock(), _createElementBlock("p", _hoisted_7, [_createElementVNode("span", null, _toDisplayString(item.otherParameter.authorName), 1), _createElementVNode("span", null, _toDisplayString(item.otherParameter.professionalTitle) + " " + _toDisplayString(item.otherParameter.departmentName) + " " + _toDisplayString(item.otherParameter.hospitalName), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      innerHTML: item.content
    }, null, 8, _hoisted_9)])])])]);
  }), 128))]);
}